<div class="alerts-form-footer">
  @if (hasEditPermission) {
    <div class="alerts-form-separator"></div>
    <div class="alerts-form-actions">
      <button class="btn-text-link"
        data-cy="alerts-create-form-actions-secondary-button"
        (click)="secondaryButtonAction.emit()">{{secondaryButtonLabel}}
      </button>
      <button class="alerts-form-actions-apply btn-primary"
        data-cy="alerts-create-form-actions-primary-button"
        [disabled]="!isPrimaryButtonDisabled"
        (click)="primaryButtonAction.emit()">{{primaryButtonLabel}}
      </button>
    </div>
    <div class="alerts-form-separator"></div>
  }
  <div class="alerts-form-footer-info">
    <div class="alerts-form-footer-info-label">Last updated by</div>
    <p class="alerts-form-footer-info-text margin-bottom"
    data-cy="alerts-form-footer-updated-by-value">{{$safeNavigationMigration(editAlertConfig?.editAlertConfigData?.updatedBy) | prettyPrintClosedBy | undefinedValue}}</p>
    <div class="alerts-form-footer-info-label">Last updated on</div>
    <p class="alerts-form-footer-info-text"
    data-cy="alerts-form-footer-updated-on-value">{{$safeNavigationMigration(editAlertConfig?.editAlertConfigData?.updatedOn) | date:'dd-MM-yyyy HH:mm:ss' | undefinedValue}}</p>
  </div>
</div>
